
import { CommonDialog } from '../../../../Common/CommonComponents'
import ProfileSvc from '../../../../../services/profile-svc';

let profileSvc = null;
export default {
    components: { CommonDialog },
    props: {
        model: {
            required: false,
            default: 100,
        },
        layout: {
            required: false,
            default: 'chain',
            type: String
        }
    },
    data() {
        return {
            visaLogo: require('../../../../../assets/img/visa-logo.png'),
            mastercardLogo: require('../../../../../assets/img//mastercard-logo.png'),
            showDialog: false,
            card: {}
        }
      },
    methods: {
        async deleteCard(tokenId) {
            this.card = await profileSvc.DeletePaymentToken(tokenId)
            if (!(this.card && this.card.pspTokenId)) {
                this.$store.commit('payment/setPaymentTokenId', null)
                profileSvc.emitSnackbar({
                    message: `Ditt kort har blitt fjernet.`, 
                    visible: true, 
                    duration: 5000, 
                    state: 'info'
                })
            } else {
                profileSvc.emitSnackbar({
                    message: `Noe gikk galt når vi forsøkte å fjerne ditt kort.`, 
                    visible: true, 
                    duration: 5000, 
                    state: 'info'
                })
            }
        },
        async changeCard(previousTokenId) {
            const wp = window.open(
                process.env.VUE_APP_CHECKOUT_WINDOW_URL,
                '_blank', 'toolbar=yes,scrollbars=yes,top=0,left=0,width=400,height=600'
            );
            await profileSvc.CreatePaymentToken().then((res) => {
                if (res) {
                    this.openSaveCreditCardWindow(res.checkoutUrl, wp, previousTokenId)
                }
            })
        },
        async addCard() {
            const wp = window.open(
                process.env.VUE_APP_CHECKOUT_WINDOW_URL,
                '_blank', 'toolbar=yes,scrollbars=yes,top=0,left=0,width=400,height=600'
            );
            await profileSvc.CreatePaymentToken().then((res) => {
                if (res) {
                    this.openSaveCreditCardWindow(res.checkoutUrl, wp)
                }
            })
        },
        async responseSwitch(status, previousTokenId, wp) {
            switch (status) {
                case 'SessionPaymentAuthorized':
                    if (previousTokenId) {
                        let card = await profileSvc.DeletePaymentToken(previousTokenId).then(async function() {
                            let i = 0;
                            let card = await new Promise(resolve => {
                                const timer = setInterval(async function () {
                                    let res = await profileSvc.GetPaymentToken();
                                    if (i >= 5 || (res && res.pspTokenId)) {
                                        clearInterval(timer);
                                        resolve(res)
                                        return res
                                    } else {
                                        i++;
                                    }
                                }, 1000);
                            })
                            wp.close();
                            return card || {}
                        });
                        return card || {}
                    } else {
                        let i = 0;
                        let card = await new Promise(resolve => {
                            const timer = setInterval(async function () {
                                let res = await profileSvc.GetPaymentToken();
                                if (i >= 5 || (res && res.pspTokenId)) {
                                    clearInterval(timer);
                                    resolve(res)
                                    return res
                                } else {
                                    i++;
                                }
                            }, 1000);
                        })
                        wp.close();
                        return card || {}
                    }
                case 'SessionCancel':
                    wp.close();
                    return {};
                case 'SessionPaymentError':
                case '':
                    wp.close();
                    return {};
                default:
                    return {}
            }
        },
        async openSaveCreditCardWindow(url, wp, previousTokenId = undefined) {
            wp.location.href = url;

            window.addEventListener('message', async (event) => {
                if (!(event.origin === process.env.VUE_APP_CHECKOUT_WINDOW_URL || event.origin === process.env.VUE_APP_FIXIT_PROFILE_URL)) {
                    return; 
                }

                const messageData = event.data;
                var card = await this.responseSwitch(messageData.paymentStatus, previousTokenId, wp)
                this.card = card
                if (card && card.pspTokenId) {
                    this.$store.commit('payment/setPaymentTokenId', card.pspTokenId)
                    profileSvc.emitSnackbar({
                    message: `Ditt kort har blitt lagret.`, 
                    visible: true, 
                    duration: 5000, 
                    state: 'info'
                })
                } else {
                    profileSvc.emitSnackbar({
                    message: `Noe gikk galt ved lagring av ditt kort.`, 
                    visible: true, 
                    duration: 5000, 
                    state: 'error'
                })
                }
            });
            /**
             * Handle when a user closes the payment window
             */
            const timer = setInterval(function () {
                if (wp && wp.closed) {
                    clearInterval(timer);
                    window.removeEventListener('message', () => {
                        return;
                    });
                    wp?.close();
                    
                }
            }, 1000);
        }
    },
    async mounted() {
        profileSvc = await ProfileSvc(this.$axios);
        this.card = await profileSvc.GetPaymentToken()
    }
}
